import React, { useState, useEffect } from "react";
import { Button, Form, AutoComplete, Input, Radio } from "antd";
import { DownOutlined } from "@ant-design/icons";
import LeftSide_Step2 from "../../images/icons/leftside_step2.jpg";
import bg_onboarding from "../../images/icons/bg_onboarding.png";

function Step2(props) {
  const {   moveBackStep, data, onFinish, formData } = props;
  const [createItemForFrontend, setCreateItem] = useState(formData.createItem || "non_inventory");
  const [optionsOfIncomeAccounts, setOptionsOfIncomeAccounts] = useState("");
  const [optionsOfExpenseAccounts, setOptionsOfExpenseAccounts] = useState("");
  const [optionsOfCogsAccounts, setOptionsOfCogsAccounts] = useState("");
  const [optionsOfAssetAccounts, setOptionsOfAssetAccounts] = useState("");
  
  const optionsCreateItems = [
    { label: "Non-Inventoried Items", value: "non_inventory" },
    { label: "Inventoried Items", value: "inventory_part" },
  ];

  useEffect(() => {
    if (data) {
      setOptionsOfIncomeAccounts(data.income);
      setOptionsOfExpenseAccounts(data.expense);
      setOptionsOfCogsAccounts(data.cogs);
      setOptionsOfAssetAccounts(data.asset);
    }
  }, [data]);

 
  function onChangeCreateItem(e) {
    
    setCreateItem(e.target.value);
  }
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="
    h-screen w-full  bg-cover bg-center lg:bg-cover lg:bg-no-repeat bg-no-repeat
    grid grid-cols-12"
    style={{
      backgroundImage: `url(${bg_onboarding})`,
      flexBasis: 0,
      flexGrow: 3,
    }}>
      {/* 1st half */}
      <div className="col-span-6">
        {/* <img className="w-full h-screen" src={LeftSide_Step2} alt="step2 image"/> */}
      </div>

      {/* 2nd half */}
      <div className="col-span-6 flex items-center justify-center w-full ">
        <div className="w-full mx-10">
          
        
          <div className="border-2 rounded-lg bg-white">
            <div className="mx-5">
            <p className="font-raleway font-normal text-xs h-4 mt-6">Step 2/4</p>
            <h1 className="font-raleway font-bold text-3xl h-4 mt-4 leading-6">
            Sync Products
            </h1>
            {/* <p className="font-raleway text-label text-gray_text_dark mt-9 mb-0.5"> Select the item type: </p> */}



              <Form
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                name="productSettings"
                layout="vertical"
                initialValues={{
                  incomeAccount: formData.item_income_account,
                  expenseAccount: formData.item_expense_account,
                  createItem: formData.createItem,
                  inventoried_IncomeAccount: formData.item_income_inventory,
                  cogsAccount: formData.item_cogs_inventory,
                  assetAccount:formData.item_asset_inventory
                }}
              >

                
                 <Form.Item
                        name = "createItem"
                        label = "Select the item type:"
                        style={{ marginTop: 24 }}
                  >
                <Radio.Group
                  options={optionsCreateItems}
                  onChange={onChangeCreateItem}
                  optionType="button"
                  buttonStyle="solid"
                  
                />
                </Form.Item>
                
                {/* non-Inventoried */}
                {createItemForFrontend === "non_inventory" ? (
                  <div className="mt-6 grid grid-cols-12 gap-6 ">
                   
                    <div className="col-span-6  ">
                      <div className="w-full">
                     
                      <Form.Item
                        name="incomeAccount"
                         label="Income Account"
                         style={{ fontWeight: 600, fontSize: "12px" }}
                         rules={[
                          {
                            required: true,
                            message: "Income account is required",
                          },

                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                optionsOfIncomeAccounts.find(
                                  (o) =>
                                    o.value === getFieldValue("incomeAccount")
                                )
                              ) {
                                return Promise.resolve();
                              }

                              return Promise.reject(
                                new Error("Select Valid Income Account")
                              );
                            },
                          }),
                        ]}
                      >
                        <AutoComplete
                          style={{
                            width: 255,
                          }}
                          options={optionsOfIncomeAccounts}
                          onChange={(value) => {}}
                          onSelect={(value) => {}}
                        >
                          <Input
                            value={"optionsOfIncomeAccounts"}
                         
                            placeholder="Select income account"
                            suffix={
                             
                              <DownOutlined />
                            }
                          />
                        </AutoComplete>
                      </Form.Item>
                      <p className="text-xs -mt-2 text-gray_hint_text">
                      This income account will be used for all new services and non-inventoried items.</p>
                    

                      </div>
                    
                      
                    </div>
                    <div className="col-span-6 ">
                      <Form.Item
                        name="expenseAccount"
                        label="Expense Account"
                        style={{
                          fontWeight: 600,
                          fontSize: "12px",
                          width: "full",
                        }}
                        rules={[
                          {
                            required: true,
                            message: "Expense account is required",
                          },

                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                optionsOfExpenseAccounts.find(
                                  (o) => o.value === getFieldValue("expenseAccount")
                                )
                              ) {
                                return Promise.resolve();
                              }

                              return Promise.reject(
                                new Error("Select Valid Expense Account!")
                              );
                            },
                          }),
                        ]}
                      >
                        <AutoComplete
                          style={{
                            width: 255,
                          }}
                           options={optionsOfExpenseAccounts}
                          onChange={(value) => {}}
                          onSelect={(value) => {}}
                        >
                          <Input
                             value={"optionsOfExpenseAccounts"}
                            // value={""}
                            placeholder="Select expense account"
                            suffix={
                              // <Icon type="search" className="certain-category-icon" />
                              <DownOutlined />
                            }
                          />
                        </AutoComplete>
                      </Form.Item>

                      <p className="text-xs -mt-2 text-gray_hint_text">
                      This expense account will be used for all new services and non-inventoried items.</p>

                    </div>
                  </div>
                ) : (
                  <>
                    {/* inventoried  */}
                    <div className="mt-5 grid grid-cols-12 gap-6 ">
                      <div className="col-span-6  ">

                        <Form.Item
                          name="inventoried_IncomeAccount"
                           label="Income Account"
                          style={{
                            fontWeight: 600,
                            fontSize: "12px",
                            width: "full",
                          }}
                          rules={[
                              {
                                required: createItemForFrontend == "inventory_part",
                                message: "Please select Income Account!",
                              },

                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  !value ||
                                  optionsOfIncomeAccounts.find(
                                    (o) => o.value === getFieldValue("inventoried_IncomeAccount")
                                  )
                                ) {
                                  return Promise.resolve();
                                }

                                return Promise.reject(
                                  new Error("Select Valid Income Account")
                                );
                              },
                            }),
                          ]}
                        >
                          <AutoComplete
                            style={{
                              width: 255,
                            }}
                             options={optionsOfIncomeAccounts}
                            onChange={(value) => {}}
                            onSelect={(value) => {}}
                          >
                            <Input
                               value={"inventoried_IncomeAccount"}
                              // value={""}
                              placeholder="Select Income account"
                              suffix={
                                // <Icon type="search" className="certain-category-icon" />
                                <DownOutlined />
                              }
                            />
                          </AutoComplete>
                        </Form.Item>
                        <p className="text-xs -mt-2 text-gray_hint_text">This income account will be used for all new services and inventoried items.</p>
                        
                      </div>

                      <div className="col-span-6  ">
                        <Form.Item
                          name="cogsAccount"
                          label="COGS Account"
                          style={{
                            fontWeight: 600,
                            fontSize: "12px",
                            width: "full",
                          }}
                          rules={[

                            {
                              required: createItemForFrontend == "inventory_part",
                              message: "Please select COGS Account",
                            },

                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  !value ||
                                  optionsOfCogsAccounts.find(
                                    (o) => o.value === getFieldValue("cogsAccount")
                                  )
                                ) {
                                  return Promise.resolve();
                                }

                                return Promise.reject(
                                  new Error("Select Valid COGS Account!")
                                );
                              },
                            }),
                          ]}
                        >
                          <AutoComplete
                            style={{
                              width: 255,
                            }}
                             options={optionsOfCogsAccounts}
                            onChange={(value) => {}}
                            onSelect={(value) => {}}
                          >
                            <Input
                               value={"optionsOfCogsAccounts"}
                              // value={""}
                              placeholder="Select deposite account"
                              suffix={
                                // <Icon type="search" className="certain-category-icon" />
                                <DownOutlined />
                              }
                            />
                          </AutoComplete>
                        </Form.Item>
                        <p className="text-xs -mt-2 text-gray_hint_text">This Cost of Sales Account for all new services and inventoried items.</p>
                      </div>
                    </div>
                    <div className=" grid grid-cols-12 gap-6 ">
                      <div className="col-span-6  ">
                        <Form.Item
                          name="assetAccount"
                          label="Asset Account"
                          style={{
                            fontWeight: 600,
                            fontSize: "12px",
                            width: "full",
                          }}
                          rules={[

                            {
                              required: createItemForFrontend == "inventory_part",
                              message: "Please select Asset Account",
                            },


                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  !value ||
                                  optionsOfAssetAccounts.find(
                                    (o) => o.value === getFieldValue("assetAccount")
                                  )
                                ) {
                                  return Promise.resolve();
                                }

                                return Promise.reject(
                                  new Error("Select Valid Class Account!")
                                );
                              },
                            }),
                          ]}
                        >
                          <AutoComplete
                            style={{
                              width: 255,
                            }}
                            options={optionsOfAssetAccounts}
                            onChange={(value) => {}}
                            onSelect={(value) => {}}
                          >
                            <Input
                              value={"optionsOfAssetAccounts"}
                              // value={""}
                              placeholder="Select deposite account"
                              suffix={
                                // <Icon type="search" className="certain-category-icon" />
                                <DownOutlined />
                              }
                            />
                          </AutoComplete>
                        </Form.Item>
                        <p className="text-xs -mt-2 text-gray_hint_text">This Inventory Asset Account for all new services and inventoried items.</p>

                      </div>
                    </div>
                  </>
                )}

                <div className="flex gap-6 justify-end mt-8 mb-9">
                  <Button
                    loading={false}
                    className="  w-24"
                    onClick={moveBackStep}
                  >
                    Back
                  </Button>

                  <Button
                    // loading={saveIsLoading}
                    className="  w-24"
                    type="primary"
                    htmlType="submit"
                   
                  >
                    Next
                  </Button>
                </div>
              </Form>
            </div>
          </div>

          
        </div>
      </div>
    </div>
  );
}

export default Step2;
